// @flow
import type { StoreResourceDef } from 'app/core/types'

export const contractAttributes: StoreResourceDef<> = {
  resourceType: 'contractAttributes',
}
